import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ChevronDown, Download, FileCheck2, FileClock, FileSignature, FileX2, Loader2 } from "lucide-react";
import { http } from "@/lib/api";
import { downloadXlsx } from "@/lib/bf";

const GROUPS = [
  ["semnate", "Semnate", "Contract semnat la toate 3 firmele", FileCheck2],
  ["resemnate", "Resemnate", "Anulate și semnate din nou la toate 3 firmele", FileSignature],
  ["de_resemnat", "De resemnat", "Anulate, așteaptă semnătura clientului", FileClock],
  ["nesemnate", "Nesemnate", "Încă nu au semnat (cu fidejusiune) la toate 3 firmele", FileX2],
];
const SHORT = { vs: "VS", fb: "FB", we: "WE" };
const ST = { semnat: "semnat", neconfirmat: "așteaptă confirmarea", fara_fid: "semnat fără fidejusiune", anulat: "anulat", "": "nesemnat" };

const Row = ({ r, admin }) => {
  const body = (
    <>
      <b>{r.salon || r.firma}</b>
      <span>{[r.firma && r.firma !== r.salon && r.firma, r.city, admin && r.agent, admin && r.no && `nr. ${r.no}`].filter(Boolean).join(" · ")}</span>
      <em>{Object.entries(r.firms).map(([k, v]) => <i key={k} className={`is-${v || "nimic"}`} title={`${SHORT[k]}: ${ST[v]}`}>{SHORT[k]}</i>)}</em>
    </>
  );
  return <li>{admin ? <Link to={`/client/${r.id}#contract`} data-testid={`bf-ca-row-${r.id}`}>{body}</Link> : <div>{body}</div>}</li>;
};

const Group = ({ g, rows, admin }) => {
  const [id, label, hint, Icon] = g;
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const shown = q.trim() ? rows.filter((r) => norm(`${r.salon} ${r.firma} ${r.city}`).includes(norm(q.trim()))) : rows;
  const xlsx = () => downloadXlsx(`/bf/contracts/overview/${id}.xlsx`, `Contracte_${id}.xlsx`).catch(() => toast.error("Nu am putut descărca"));
  return (
    <div className={`bf-ca-group is-${id}`} data-testid={`bf-ca-group-${id}`}>
      <div className="bf-ca-head">
        <Icon size={18} /><div><b>{label}</b><small>{hint}</small></div>
        <span className="bf-ca-count" data-testid={`bf-ca-count-${id}`}>{rows.length}</span>
        {admin && <button type="button" className="st-btn st-btn--ghost" onClick={xlsx} disabled={!rows.length} data-testid={`bf-ca-xlsx-${id}`}><Download size={14} /> Excel</button>}
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(!open)} disabled={!rows.length} data-testid={`bf-ca-toggle-${id}`}>
          {open ? "Ascunde clienții" : "Arată clienții"} <ChevronDown size={14} className={open ? "is-up" : ""} />
        </button>
      </div>
      {open && (
        <>
          <input className="bf-ca-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută salon, firmă sau oraș" data-testid={`bf-ca-search-${id}`} />
          <ul className="bf-ca-list" data-testid={`bf-ca-list-${id}`}>{shown.map((r, i) => <Row key={r.id || i} r={r} admin={admin} />)}</ul>
          {!shown.length && <p className="st-hint" data-testid={`bf-ca-empty-${id}`}>Niciun client găsit.</p>}
        </>
      )}
    </div>
  );
};

export default function BFContractsArea({ admin = false }) {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/bf/contracts/overview").then((r) => setData(r.data)).catch(() => setData(false)); }, []);
  if (data === false) return <p className="st-hint">Nu am putut încărca situația contractelor.</p>;
  return (
    <section className="invite-box bf-ca" data-testid="bf-contracts-area">
      <h3><FileSignature size={18} /> Situația contractelor</h3>
      {!data ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <>
          <p className="st-hint" data-testid="bf-ca-summary">{GROUPS.map(([id, l]) => `${data[id].length} ${l.toLowerCase()}`).join(" · ")}{admin ? ". Apasă pe un client ca să deschizi contractul (acolo ai Resemnează)." : ""}</p>
          <div className="bf-ca-groups">{GROUPS.map((g) => <Group key={g[0]} g={g} rows={data[g[0]]} admin={admin} />)}</div>
        </>
      )}
    </section>
  );
}
